import { useRef } from "react";
import { ISettingBtnProps } from "./SettingBtn.props";
import cn from "classnames";
import styles from "./SettingBtn.module.scss";
import { Button as AntButton, Input, InputRef, Tooltip } from "antd";
import { MAX_NUMBER, useSettingBtnControl } from "./useSettingBtnControl";
import Icon from "@components/global/new/Icon/Icon";
import deleteIcon from "@assets/redesign/icons/trash.svg";
import { useIntl } from "react-intl";

import { ReactComponent as MinerIcon } from "@assets/icons/icon_miner.svg";

export default function SettingBtn({ ...props }: ISettingBtnProps) {
  const inputRef = useRef<InputRef>(null);
  const { formatMessage } = useIntl();
  const control = useSettingBtnControl(props);

  const minerTitle = props.setting
    ? props.setting.cloned_miner
    : props.children;

  const onEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      control.addMiner();
    }
  };

  return (
    <div className={styles.setting}>
      <Tooltip
        open={props.isDefault ? false : undefined}
        placement='left'
        trigger={"click"}
        afterOpenChange={() => inputRef.current?.focus()}
        title={
          <div className={styles.counter}>
            <Input
              className={styles.input}
              value={control.inputValue}
              onChange={(e) => control.onChangeInput(e.target.value)}
              type='number'
              size='small'
              ref={inputRef}
              min={1}
              max={MAX_NUMBER}
              prefix={<MinerIcon className={styles.icon} />}
              status={
                control.inputValue < 1 || control.inputValue > MAX_NUMBER
                  ? "error"
                  : undefined
              }
              onKeyDown={onEnter}
            />
            <AntButton
              className={styles.btn}
              size='small'
              onClick={control.addMiner}
            >
              {formatMessage({
                id: "location.equipment.connection_info.apply",
              })}
            </AntButton>
          </div>
        }
        color='white'
      >
        <AntButton
          className={styles.btn}
          size='small'
          onClick={props.isDefault ? control.addMiner : undefined}
          title={minerTitle}
        >
          <label className={styles.miner}>[{minerTitle}]</label>
        </AntButton>
      </Tooltip>
      {!!props.setting && (
        <Icon
          src={deleteIcon}
          className={styles.delete_icon}
          onClick={control.onDeleteSetting}
        />
      )}
    </div>
  );
}
